import { A } from "@solidjs/router";
import type { JSX } from "solid-js";
import { styled } from "solid-styled-components";

export const MenuItemWrapper = styled(A)<{ w?: JSX.CSSProperties["width"]; settings?: boolean }>`
  min-height: 56px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 0 15px;
  transition: all 0.2s;
  ${({ theme, w }) => `color:${theme?.colors.accentTertiary}; ${w ? `width:${w};` : ""} `}

  &:hover {
    text-decoration: none;
    ${({ theme }) => `color:${theme?.colors.accentTertiary};`}
    background-color: ${({ theme }) => theme?.colors.accentQuinary};
  }
  &:is(.active) {
    ${({ theme }) => `
      color: ${theme?.colors.accentPrimary};
      background: ${theme?.colors.accentQuinary};
  `}
  }
  h3 {
    font-size: 18px;
  }

  ${({ settings, theme }) =>
		settings
			? `@media only screen and (max-width: 1700px) {
    flex-direction: column;
    width: 100%;
    height: 150px;
    padding: 0;
    flex: 1;
    min-width: 350px;
    justify-content: center;
    a {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      svg {
        margin: 0 0 15px 0;
      }
      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 180px;
        text-align: center;
      }
    }
    border: 2px solid ${theme?.colors.accentTertiary}30;
  }`
			: ""}
`;
